import { useState } from "react";
import { TooltipInfo } from "../../../models/tooltipInfo";
import TooltipModal from "../../modals/tooltipModal/TooltipModal";
import "./TooltipButton.scss";

const TooltipButton = (props: TooltipInfo) => {
  const ViewTooltipOnly = () => {
    return (
      <>
        <button
          className="help-icon"
          type="button"
          data-target="#help-icon"
          title={props.tooltipText}
          aria-label={props.tooltipText}
        >
          ?
        </button>
      </>
    );
  };
  const ViewTooltipWithModal = () => {
    const [modalShow, setModalShow] = useState(false);
    return (
      <>
        <button
          className="help-icon"
          type="button"
          data-toggle="modal"
          data-target="#help-icon-modal"
          title={props.tooltipText}
          aria-label={props.tooltipText}
          onClick={() => setModalShow(true)}
        >
          ?
        </button>
        <TooltipModal
          title={props.modal?.title}
          body={props.modal?.body}
          show={modalShow}
          closeButtonHide={props.modal?.closeButtonHide}
          onHide={() => setModalShow(false)}
        />
      </>
    );
  };
  return props.modal ? <ViewTooltipWithModal /> : <ViewTooltipOnly />;
};
export default TooltipButton;
